import type {
  IntegrationSettings,
  PhoneNumberIntegrationIdsMap,
} from '@entities/integration';
import type { IntegrationRepository } from '@infra/repositories/integration.repository';

export class MemIntegrationRepository implements IntegrationRepository {
  private settingsMap = new Map<number, IntegrationSettings>();
  private phoneNumberIntegrationIdsMap?: PhoneNumberIntegrationIdsMap;

  async getSettingsById(
    integrationId: number,
  ): Promise<IntegrationSettings | undefined> {
    const settings = this.settingsMap.get(integrationId);

    return settings;
  }

  async getLatestIntegrationSettings(): Promise<
    IntegrationSettings | undefined
  > {
    const settings = this.settingsMap.get(Math.max(...this.settingsMap.keys()));

    return settings;
  }

  async saveSettingsBatch(batch: IntegrationSettings[]): Promise<void> {
    batch.forEach((integration) => {
      this.settingsMap.set(integration.integrationId, integration);
    });
  }

  async saveSetting(setting: IntegrationSettings): Promise<void> {
    this.settingsMap.set(setting.integrationId, setting);
  }

  async getIntegrationIdsByPhoneNumberId(
    numberId: string,
  ): Promise<number[] | void> {
    if (this.phoneNumberIntegrationIdsMap)
      return this.phoneNumberIntegrationIdsMap[numberId]?.integrationIds;
  }

  async savePhoneNumberIntegrationIdsMap(
    map: PhoneNumberIntegrationIdsMap,
  ): Promise<void> {
    this.phoneNumberIntegrationIdsMap = map;
  }

  async getAircallToCRMStatusIdMappingByPhoneNumber(
    numberId: number,
  ): Promise<string> {
    const integrationIds = await this.getIntegrationIdsByPhoneNumberId(
      numberId.toString(),
    );
    if (!integrationIds || integrationIds.length === 0) return '';

    // if multuiple integration found, we will use the latest one
    const integrationId = Math.max(...integrationIds);
    const settings = await this.getSettingsById(integrationId);
    const crmStatusId = settings?.sections['omnichannel_aircall_to_sf']
      ?.settings.salesforce_in_call_status as string;
    return crmStatusId;
  }
}

/*
 * We don't really know why, but SF OmniChannel JS SDK only works if we cut
 * the last three characters from the Status ID ¯\_(ツ)_/¯
 */
export function transformCrmStatusId(crmStatusId: string): string {
  return crmStatusId.substring(0, crmStatusId.length - 3);
}
